// @deprecated
// replaced with pretty-bytes
export const sizeFormat = (bytes: number = 0): string =>
   require('filesize')(bytes)
